import { atom } from "recoil"

export const inquirySelectedOrganizationState = atom<string | undefined>({
  key: "atoms/settings/inquirySelectedOrganizationState",
  default: undefined,
})
